<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        :basic-data="basicData"
        sort="name"
        title="Client Type List"
        icon="mdi-account-network"
        addButtonText="Client Type"
        stateendpoint="clientType.clientTypes"
        :actions="actions"
        :action-buttons="actionButton"
        :show-default-action-buttons="false"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import ClientTypePopup from "../components/popups/ClientTypePopup";

export default {
  name: 'ClientTypes',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Client Types | %s',
    meta: [
      {name: 'robots', content: 'noindex'},
      {name: 'googlebot', content: 'noindex'}
    ]
  },
  components: {
    ListPage,
    ClientTypePopup
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'action'},
      ],
      actions: {
        load: 'loadClientTypes',
        create: 'storeClientType',
        update: 'updateClientType',
        remove: 'destroyClientType',
      },
      basicData: {
        name: "",
        status: 1,
      },
      actionButton: [
        {
          category: 'edit',
          icon: 'mdi-pencil',
          color: '',
          text: 'Edit',
          clickHandler: 'editItem'
        },
        {
          category: 'delete',
          icon: 'mdi-delete-alert',
          color: 'error',
          text: 'Delete',
          clickHandler: 'deleteItem'
        },
      ],
    }
  },
  computed: {
    popupComponent() {
      return ClientTypePopup;
    }
  }
}
</script>
